// extracted by mini-css-extract-plugin
export default {"namingInput":"Naming-namingInput-k33Yg TextInput-input-svfXu Input-input-KWeec"};